import React from 'react';
import { Box, CircularProgress, makeStyles, Theme, createStyles, Typography } from '@material-ui/core';

export interface ILoadingScreen {
  label?: string
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    loadingContainer: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignContent: 'center',
      width: '100%',
      height: '100vh',
      padding: theme.spacing(),
      boxSizing: 'border-box'
    },
    loading: {
      alignSelf: 'center'
    },
    label: {
      textAlign: 'center',
      marginTop: '15px'
    }
  }),
);

export default ({label}: ILoadingScreen) => {
  const classes = useStyles();

  return (
    <Box className={classes.loadingContainer}>
      <CircularProgress color="primary" className={classes.loading} />
      {
        label ? (
          <Typography className={ classes.label }>
            { label }
          </Typography>
        ) : null
      }
    </Box>
  );
}